
import React, { useCallback, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TextField,
  Paper,
  Typography,
  CircularProgress,
} from '@material-ui/core';
import Layout from './Layout';

export const Farms = () => {
  const [orgID, setOrgID] = useState('');
  const [farmID, setFarmID] = useState('');
  const [emailID, setEmailID] = useState('');
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isInputEmpty, setIsInputEmpty] = useState(false);

  const baseUrl = window.environment === 'dev' ? 'https://dev.phyfarm.com/' : 'https://v3.api.phyfarm.com/';

  const onSubmit = useCallback(
    function (e) {

      if (!orgID && !farmID && !emailID) {
        setIsInputEmpty(true);
        return;
      }

      setLoading(true);
      setIsInputEmpty(false);

      if (farmID) {

        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
          },
          body: JSON.stringify({
            farm_id: parseInt(farmID, 10),
          }),
        };

        fetch(baseUrl + 'api/mgmt/farm/getFarmById', requestOptions)
          .then((response) => response.json())
          .then((data) => {

            if (data.error) {
              setError(data.error);
            }
            if (data.data) {
              setResponseData({ data: [data.data] });
            }
            else {
              setResponseData({ data: [] })
            }

            setLoading(false);
          })
          .catch((error) => {
            setError(error);
            setLoading(false);
          });
      }

      if (orgID) {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
          },
          body: JSON.stringify({
            org_id: parseInt(orgID, 10),
          }),
        };

        fetch(baseUrl + 'api/mgmt/farm/listFarmsByOrg', requestOptions)
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            setResponseData(data);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      }

      if (emailID) {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
          },
          body: JSON.stringify({
            email: emailID,
          }),
        };

        fetch(baseUrl + 'api/mgmt/farm/listFarmsByEmail', requestOptions)
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            setResponseData(data);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      }
    },
    [farmID, orgID, emailID]
  );

  const handleDelete = (item) => {
    const deleteEnvResponse = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        farm_id: item,
      }),
    };

    fetch(baseUrl + 'api/mgmt/farm/archiveFarm', deleteEnvResponse)
      .then((deleteMacResponse) => deleteMacResponse.json())
      .then((res) => {
        onSubmit();
      });
  };

  console.log('responseData', responseData);
  return (
    <Layout>
      <div className="App">
        <div style={{ marginTop: 100 }}>
          <Typography variant="h5" style={{ marginBottom: 15 }}>
            List of Farms
          </Typography>
        </div>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 30 }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <TextField
              label="Org ID"
              value={orgID}
              onChange={(e) => setOrgID(e.target.value.trim())}
              variant="outlined"
              style={{ marginRight: 20 }}
              error={isInputEmpty && !orgID}
              helperText={isInputEmpty && !orgID ? 'Please enter OrgID Address' : ''}
            />

            <Typography variant="subtitle1" style={{ color: '#777', margin: '15px 30px' }}>
              - OR -
            </Typography>

            <TextField
              label="Farm ID"
              value={farmID}
              onChange={(e) => setFarmID(e.target.value.trim())}
              variant="outlined"
              style={{ marginRight: 20 }}
              error={isInputEmpty && !farmID}
              helperText={isInputEmpty && !farmID ? 'Please enter Farm ID' : ''}
            />

            <Typography variant="subtitle1" style={{ color: '#777', margin: '15px 30px' }}>
              - OR -
            </Typography>

            <TextField
              label="Email ID"
              value={emailID}
              onChange={(e) => setEmailID(e.target.value.trim())}
              variant="outlined"
              error={isInputEmpty && !emailID}
              helperText={isInputEmpty && !emailID ? 'Please enter emailID' : ''}
            />
          </div>

          <Button style={{ marginTop: 20 }} type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </form>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
            <CircularProgress />
          </div>
        ) : (
          <TableContainer component={Paper} style={{ marginTop: 30 }}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    ID
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Org ID
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Size
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Name
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    State
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Pincode
                  </TableCell>
                  <TableCell align="center" style={{ fontWeight: 'bold' }}>
                    Remove
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {responseData && responseData.data && Array.isArray(responseData.data) && responseData.data.length > 0 ? (
                  responseData.data.map((item, index) => (
                    <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell align="center" component="th" scope="row">
                        {item.id}
                      </TableCell>
                      <TableCell align="center">{item.org_id}</TableCell>
                      <TableCell align="center">{item.size}</TableCell>
                      <TableCell align="center">{item.name}</TableCell>
                      <TableCell align="center">{item.state}</TableCell>
                      <TableCell align="center">{item.pincode}</TableCell>
                      <TableCell align="center">
                        <Button variant="outlined" color="secondary" onClick={() => handleDelete(item.id)}>
                          Archive
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      {responseData && responseData.data === null ? (

                        <Typography variant="subtitle1">No data available</Typography>
                      ) : (

                        responseData && responseData.error ? (
                          <Typography variant="subtitle1">No data available</Typography>
                        ) : (
                          responseData && responseData.data && responseData.data.length === 0 ? (
                            <Typography variant="subtitle1">No data available</Typography>
                          ) : null)
                      )}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </Layout>
  );
};

export default Farms;